<script>
import { Regions } from '@/config'

import SingleSelectFilter from './SingleSelectFilter.vue'

export default {
  name: 'RVBRegionsFilter',
  mixins: [SingleSelectFilter],
  computed: {
    options() {
      return Regions.map(option => {
        return {
          value: option,
          text: option,
        }
      })
    },
  },
}
</script>
